import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import ReCAPTCHA from "react-google-recaptcha";
import AuthLayout from "./ui/AuthLayout";
import Field from "./ui/Field";
import Button from "./ui/Button";

export default function Signup() {
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const captchaRef = useRef(null);

  const navigate = useNavigate();
  useEffect(() => {
    if (auth?.currentUser) navigate("/");
  }, [navigate]);

  const onRecaptchaChange = (value) => {
    if (value) setValidated(!!value);
  };
  const onChangeHandler = (e) => {
    setUser((prevUser) => {
      return { ...prevUser, [e.target.name]: e.target.value };
    });
    if (error) setError("");
  };
  const submitHandler = (event) => {
    event.preventDefault();
    if (!validated) {
      setError("Please complete the reCAPTCHA first.");
      return;
    }
    createUserWithEmailAndPassword(auth, user.email, user.password)
      .then((userCredential) => {
        setDoc(doc(db, "users", userCredential.user.uid), {
          email_address: userCredential.user.email || user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          Admin: false,
          status: false,
          processedFile: "null",
        });
        navigate("/login");
      })
      .catch((err) => {
        console.error("signup error", err?.code);
        if (err.code === "auth/email-already-in-use") {
          setError("This email is already in use. Try logging in instead.");
        } else if (err.code === "auth/weak-password") {
          setError("Password should be at least 6 characters.");
        } else {
          setError("Something went wrong. Please try again.");
        }
        captchaRef.current?.reset();
        setValidated(false);
      });
  };

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Get started with Cloud Voice Processor."
      footer={
        <>
          Already a member?{" "}
          <a
            href="/login"
            className="font-medium text-accent transition-colors hover:text-accent-soft"
          >
            Login
          </a>
        </>
      }
    >
      <form onSubmit={submitHandler} className="space-y-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <Field
            label="First name"
            id="signup-fname"
            hideLabel
            type="text"
            name="firstName"
            value={user.firstName}
            onChange={onChangeHandler}
            autoComplete="given-name"
            placeholder="First name"
            required
          />
          <Field
            label="Last name"
            id="signup-lname"
            hideLabel
            type="text"
            name="lastName"
            value={user.lastName}
            onChange={onChangeHandler}
            autoComplete="family-name"
            placeholder="Last name"
            required
          />
        </div>
        <Field
          label="Email"
          id="signup-email"
          hideLabel
          type="email"
          name="email"
          value={user.email}
          onChange={onChangeHandler}
          autoComplete="email"
          placeholder="Email"
          required
        />
        <Field
          label="Password"
          id="signup-password"
          hideLabel
          type="password"
          name="password"
          value={user.password}
          onChange={onChangeHandler}
          autoComplete="new-password"
          placeholder="Password"
          required
        />

        {error && (
          <p role="alert" className="text-sm text-red-400">
            {error}
          </p>
        )}

        <div className="flex justify-center">
          <ReCAPTCHA
            ref={captchaRef}
            theme="dark"
            sitekey={"6Ldkj3EkAAAAAPYdhU4e2OOm2kjR1Kg_ChmA_h16"}
            onChange={onRecaptchaChange}
          />
        </div>

        <Button type="submit" variant="primary" className="w-full">
          Sign up
        </Button>

        <p className="text-xs leading-5 text-white/40">
          By signing up, you agree to our{" "}
          <button
            type="button"
            className="font-medium text-white/70 hover:text-white hover:underline"
          >
            Terms
          </button>
          ,{" "}
          <button
            type="button"
            className="font-medium text-white/70 hover:text-white hover:underline"
          >
            Data Policy
          </button>{" "}
          and{" "}
          <button
            type="button"
            className="font-medium text-white/70 hover:text-white hover:underline"
          >
            Cookies Policy
          </button>
          .
        </p>
      </form>
    </AuthLayout>
  );
}
